import { ToplistItem } from "../../Shared/Services/Campaign/interfaces"

export enum TopListSize {
    Default = 10,
    Expanded = 1000,
}

export type TopListProps = {
    items: ToplistItem[]
    ownItems: ToplistItem[]
    isSearched: boolean
    useGlobalTopList: boolean
}
